import { Component } from '@angular/core';
import { Router, ActivatedRoute, RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { TokenStorageService } from 'src/app/services/token_storage.service';
import { MatToolbar } from '@angular/material/toolbar';
import { MatIconButton, MatButton, MatButtonModule } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatSidenavContainer, MatSidenav, MatSidenavContent, MatSidenavModule } from '@angular/material/sidenav';
import { MatNavList, MatListItem } from '@angular/material/list';
import { KeyValuePipe } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';

@Component({
    selector: 'navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss'],
    imports: [
        MatToolbar, 
        MatIconButton, 
        MatIcon,
        RouterLink,
        MatSidenavContainer, 
        MatSidenav,
        MatSidenavModule, 
        MatNavList, 
        MatListItem, 
        RouterLinkActive, 
        MatButtonModule, 
        MatSidenavContent, 
        RouterOutlet, 
        KeyValuePipe,
        MatFormFieldModule
    ]
})

export class NavbarComponent {
    opened = true;

    routes = new Map([
        ['application', 'User Applications'],
        ['service-application', 'Provider Applications'],
    ]);

    adminRoutes = new Map([
        ['application', 'User Applications'],
        ['employee', 'Employees'],
        ['settings', 'Settings'],
        ['customers', 'Customers'],
    ]);

    constructor(
        private router: Router,
        private tokenStorage: TokenStorageService,
        private tokenStorageService: TokenStorageService,
    ) {}

    get getLoggedInUserRole(): string {
        return this.tokenStorageService.getUser()?.employeeRole ?? '';
    }

    logout(): void {
        sessionStorage.clear();
        this.router.navigate(['login']);
    }

    get showSidenav(): boolean {

        if (!this.isUserLoggedIn) {
            return false;
        } else {
            return this.opened;
        }
    }

    toggleSidenav(): void {
        this.opened = !this.opened;
    }

    get isUserLoggedIn(): boolean {
        if (this.tokenStorage.getUser() != null && this.tokenStorage.getToken() != null) {
            return true;
        }
        return false;
    }
}
